import { css } from '@emotion/css'
import { ReactNode } from 'react'
import { IconWrapper, SecondaryAuthContainer } from './SecondaryAuth.styled'
import { useTheme } from '@mui/material'
import { useLocation, useParams } from 'react-router-dom'

import { useSnackbar } from 'notistack'
import { ICaptchaVerify } from 'src/types'

const CONNECT_USER_TO_X_PROVIDER = 'connect_to_x_provider-'
interface IProps {
  captcha: ICaptchaVerify
  icon: ReactNode
  auth: string
  mb?: number
  disabled?: boolean
}

export const SecondaryAuth = ({ captcha, icon, auth, mb, disabled = false }: IProps) => {
  const theme = useTheme()
  const { enqueueSnackbar } = useSnackbar()

  const { token } = useParams()
  const location = useLocation()
  const { state } = location || {}
  const isConnectTox = state?.provider === 'x' && state?.userId

  const handleAuthClick = (authType: string) => async () => {
    if (disabled) return

    if (!captcha?.verificationResp) {
      const isVerified = await captcha?.verifyAsync()

      if (!isVerified) {
        enqueueSnackbar('Verification failed. Please try again', { variant: 'error' })

        return
      }
    }

    window.open(
      `${process.env.REACT_APP_BACKEND_URL}/auth/${authType}${token ? '?token=' + token : isConnectTox ? '?token=' + CONNECT_USER_TO_X_PROVIDER + state?.userId : ''}`,
      '_self',
    )
  }
  return (
    <div
      onClick={handleAuthClick(auth)}
      className={css(
        SecondaryAuthContainer,
        `border: 0.5px solid ${theme.palette.custom.darkBlue2};`,
        disabled
          ? `opacity: 0.5; pointer-events: none;` // Style as disabled
          : `&&:hover {
               background-color: ${theme.palette.custom.grey};
             }`,
      )}
    >
      <div className={css(IconWrapper, mb ? `margin-bottom: ${mb}px;` : '')}>{icon}</div>
    </div>
  )
}
